import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlertLoading,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteSetorCliente, getSetorClienteById } from '../../core/_request'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { SetorClienteModal } from '../../components/modal/SetorClienteModal'
import { SetorAsoList } from '../../core/_models'

type Props = {
  setor: SetorAsoList
}

export const SetorActionsCell: FC<Props> = ({ setor }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = setor.nome || 'Setor'

  const openEditModal = () => {
    showModal({
      title: 'Setor',
      content: <SetorClienteModal />,
      size: ModalSize.Medium,
      fetchers: {
        setor: () => getSetorClienteById(setor.id),
      },
    })
  }

  // Excluir é destrutivo: confirmação com a consequência.
  const askDelete = async () => {
    const confirmed = await showConfirmAlert({
      title: 'Excluir setor?',
      text: `${nome} será excluído. Essa ação não pode ser desfeita.`,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmed) return

    try {
      showAlertLoading()
      await deleteSetorCliente(setor.id)
      Swal.close()
      showToast({ variant: 'success', title: `${nome} foi excluído.` })
      refetch()
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{ label: 'Alterar', onClick: openEditModal, icon: IconPaths.Pen }}
      items={[{ label: 'Excluir', onClick: askDelete, danger: true }]}
    />
  )
}
